// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tab_wrapper__33zjO","select":"Tab_select__1a79v","option":"Tab_option__1vG8U","active":"Tab_active__2juO7","disabled":"Tab_disabled__3Ggcc"};